import React from 'react';
import { Link } from 'react-router'
import { translate } from "react-multi-lang";

let baseUrl = window.location.origin;

let websiteUrl, cmsUrl;

if (baseUrl == "http://localhost:3002") {
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}
else if (baseUrl == "http://uatweb.pgrkam.com") { 
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}
else if (baseUrl == "http://pgrkam.com") {
  websiteUrl = baseUrl;
  cmsUrl = "http://cms.pgrkam.com"
}
else {
  websiteUrl = baseUrl;
  cmsUrl = "http://uatcms.pgrkam.com"
}


const ArchivalPolicy = (props) => {
  const { t } = props;
  return (
    <div className="tab-content">
      <div id="home" className=" tab-pane active">
        <section className="login-form mt-0">
          <div className="container">
            <div className="row">
              <div className="col-md-12 p-0 mx-auto  tab-content border-0 cover-shadow mb-3 mt-3">
                <div className="panel-heading">
                  <div className="mb-0">{t('archival.archival', { param: 'react' })}</div>
                </div>
                <div className="panel-body p-policy pt-0 p-3">
                  <div className="policypage hightset">
                    <Link className="mt-3" to="/archived-tenders" aria-label="Archived tenders"><img src="images/arrowtre.jpg" className='me-2' alt="" />  {t('archival.archived_tenders', { param: 'react' })}</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div >
    </div >
  )
}

export default translate(ArchivalPolicy);